import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

export const vendorBasePath = '/vendors';
export const vendorTeamPath = `${vendorBasePath}/:id`;
export const vendorReportPath = `${vendorBasePath}/report`;
export const vendorLevelPayoutPath = `${vendorBasePath}Payout`;
export const vendorPayoutPath = `${vendorLevelPayoutPath}/:id`;

const getVendorsRoutes: ModuleRoutesComponentInterface = () => [
  {
    id: ModuleConstants.VENDORS,
    route: vendorBasePath,
    title: ScreenNames.VENDORS,
    icon: generateImage({
      noScale: true,
      name: 'user-white',
      alt: 'users',
      className: 'w-4 h-4',
    }),
    component: ComponentsMap.VENDORS,
    children: [
      {
        id: ModuleConstants.TEAM_MANAGEMENT,
        route: vendorTeamPath,
        title: ScreenNames.TEAM_MANAGEMENT,
        component: ComponentsMap.TEAM_MANAGEMENT,
        sidebarVisibility: false,
      },
      {
        id: ModuleConstants.VENDOR_SALARY_PAYOUT,
        route: vendorLevelPayoutPath,
        title: ScreenNames.VENDOR_LEVEL_PAYOUT,
        component: null,
        redirect: true,
        sidebarVisibility: false,
        children: [
          {
            id: ModuleConstants.VENDOR_SALARY_PAYOUT,
            route: vendorPayoutPath,
            title: ScreenNames.VENDOR_PAYOUT_VIEW,
            component: ComponentsMap.VENDOR_PAYOUT_VIEW,
            sidebarVisibility: false,
          },
        ],
      },
    ],
  },
];

export default getVendorsRoutes;
